import { ReactComponent as PlannedIcon } from './icons/planned.svg';
import { ReactComponent as UnplannedIcon } from './icons/unplanned.svg';
import { ReactComponent as SageIcon } from './icons/sage.svg';
import { BUILD_DATE } from '../../build-number';
import { OUTAGE_PAGE_CONFIG } from './outage-page-config';
import './OutagePage.scss';

const STATIC_LAST_UPDATED_FALLBACK = '2:15 PM';

function formatLastUpdated(): string {
    if (!BUILD_DATE) return STATIC_LAST_UPDATED_FALLBACK;
    const parsed = new Date(BUILD_DATE);
    if (Number.isNaN(parsed.getTime())) return STATIC_LAST_UPDATED_FALLBACK;
    return parsed.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
    });
}

export default function OutagePage() {
    const { variant, appName, planned } = OUTAGE_PAGE_CONFIG;
    const lastUpdated = formatLastUpdated();

    const isPlanned = variant === 'planned';
    const Icon = isPlanned ? PlannedIcon : UnplannedIcon;
    const title = isPlanned
        ? `${appName} will be temporarily unavailable`
        : `${appName} Service Disruption`;

    return (
        <div className={`outage-page outage-page--${variant}`}>
            <div className="outage-page__card">
                <div className="outage-page__title" role="heading" aria-level={1}>
                    {title}
                </div>
                <div className="outage-page__body">
                    <Icon className="outage-page__icon" aria-hidden="true" />
                    <div className="outage-page__text">
                        {isPlanned ? (
                            <>
                                <p>
                                    {appName} will be unavailable due to scheduled maintenance
                                    to improve performance and reliability.
                                </p>
                                <p>
                                    Start: {planned.startDate}
                                    <br />
                                    End: {planned.endDate}
                                </p>
                                <p>Service will resume automatically once maintenance is complete.</p>
                            </>
                        ) : (
                            <p>
                                We're experiencing a service disruption affecting {appName}. Our team
                                is working to restore service as quickly as possible. We apologize
                                for the inconvenience. We'll provide updates here.
                            </p>
                        )}
                    </div>
                </div>
            </div>
            <div className="outage-page__footer">
                <div className="outage-page__footer-left">Last updated: {lastUpdated}</div>
                <div className="outage-page__footer-right">
                    <SageIcon className="outage-page__sage-icon" aria-hidden="true" />
                    <span>The Sage Team</span>
                </div>
            </div>
        </div>
    );
}
